import { render, staticRenderFns } from "./ProfileReviews.vue?vue&type=template&id=2e94823f&scoped=true&"
import script from "./ProfileReviews.vue?vue&type=script&lang=js&"
export * from "./ProfileReviews.vue?vue&type=script&lang=js&"
import style0 from "./ProfileReviews.vue?vue&type=style&index=0&id=2e94823f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e94823f",
  null
  
)

export default component.exports